/**
 * The package's staleness vocabulary — every query hook picks a tier instead of
 * inlining a number, so "how fresh must this be" is decided (and changed) in
 * ONE place. Tiers preserve the exact values the hooks already used; pick by
 * intent, not by number:
 *
 * - `live`   — surfaces tracking a single record someone is acting on right now
 *              (ticket detail, watchers, a pending approval, onboarding progress).
 * - `fast`   — lists and feeds that move with desk activity (tickets, activity,
 *              stats, teams). The package default.
 * - `config` — admin-shaped data that changes on deliberate action (masters,
 *              settings, departments, watcher rules, escalation).
 * - `rare`   — per-user RBAC assignments (change on admin action, but visible
 *              consequences make moderate staleness acceptable).
 * - `slow`   — analytics / heavy roll-ups where minutes-old is fine.
 * - `static` — catalogs that change on deploy more than at runtime (permission
 *              definitions).
 */
export const STALE_TIME = {
  live: 15_000,
  fast: 30_000,
  config: 60_000,
  rare: 2 * 60_000,
  slow: 5 * 60_000,
  static: 10 * 60_000,
} as const;
